export default __webpack_public_path__ + "static/media/uploadIcon.2f437db1.svg";